import { useContext } from 'react';
import styled from 'styled-components';
import i18n from 'src/utils/translate';
import { useDispatch, useSelector } from 'src/store/store';
import { titleLarge } from 'styles-js/mixins/typography';

import { DefaultLayout } from 'src/components/layouts';
import EmailTypeSection from 'src/modules/unsubscribe/emailTypeSection';
import { LinkButton } from 'styles-js/buttons';
import { showModal } from 'src/modules/shared/modal/actions';
import { emailTypes } from 'src/modules/unsubscribe/unsubscribeUtils';
import { updateEmailPreferences } from 'src/api/emailNotifications';
import { setAlert } from 'src/components/alert/actions';
import ErrorBanner from 'src/modules/unsubscribe/errorBanner';
import { NotificationsContext } from 'pages/emailNotifications';
import { trackFootfallEvent } from 'src/utils/footfall';
import { Event, Section } from 'src/constants/footfall';
import { ModalType } from 'src/constants/modalTypes';

export default function EmailNotificationsPage() {
  const dispatch = useDispatch();
  const { currentUser } = useSelector((state) => state.context);
  const { token, refreshData } = useContext(NotificationsContext);

  const unsubscribeAllEmails = async () => {
    const allEmailPreferencesDisabled = emailTypes.map(email => {
      return {
        notificationId: email.notificationId,
        enabled: false,
      };
    });

    const updatedPreferences = await updateEmailPreferences(allEmailPreferencesDisabled, token, currentUser?.userId);

    if (updatedPreferences) {
      refreshData(updatedPreferences);
      trackFootfallEvent(Event.CLICKED, {
        clickType: 'email-preferences',
        clickMetadata: { section: Section.UnsubscribeAllAccepted },
      });
      dispatch(setAlert(i18n.t('You unsubscribed from all emails'), 'success', 6000));
    } else {
      dispatch(setAlert(<ErrorBanner />, 'danger', 6000));
    }
  };

  const onUnsubscribeAllClick = () => {
    trackFootfallEvent(Event.CLICKED, {
      clickType: 'email-preferences',
      clickMetadata: { section: Section.UnsubscribeAllViewed },
    });
    dispatch(showModal({
      modalType: ModalType.EmailUnsubscribeAllEmails,
      modalProps: {
        onAccept: () => unsubscribeAllEmails(),
      },
    }));
  };

  return (
    <DefaultLayout>
      <Container>
        <Title>{i18n.t('Email notifications')}</Title>
        <EmailTypeSection
          emailType="Account"
          title={i18n.t('From my account')}
        />
        <EmailTypeSection
          emailType="Community"
          title={i18n.t('From my communities')}
        />
        <EmailTypeSection
          emailType="HealthUnlocked"
          title={i18n.t('From HealthUnlocked')}
        />
        <UnsubscribeAllButton data-testid="UnsubscribeFromAllEmails" onClick={onUnsubscribeAllClick}>
          {i18n.t('Unsubscribe from all emails')}
        </UnsubscribeAllButton>
      </Container>
    </DefaultLayout>
  );
}

const Container = styled.div`
  padding: 0 15px;
`;

const Title = styled.div`
  ${titleLarge};
  padding: 30px 0 15px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colorGreyLight};
`;

const UnsubscribeAllButton = styled(LinkButton)`
  margin: 30px 0;
`;
